import { type VehicleSearchProps } from '@allesauto/core/vehicleSearch';
import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import { pushAnalyticsEvent } from '@allesauto/utils/analytics';
import { getPcpUrl } from '@allesauto/utils/routeUtils';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { deleteAllFilters } from '@/store/redux/actions/pages/pcp';

type OnSubmit = VehicleSearchProps['onSubmit'];

const getHeroAction = (priceRangeKey: string) => {
  switch (priceRangeKey) {
    case 'CASH_RANGE':
      return 'barkauf';
    case 'LOAN_RATE_RANGE':
      return 'finanzierung';
    case 'LEASING_RATE_RANGE':
      return 'leasing';
    default:
      return '';
  }
};

export const useOnSubmit = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const whiteLabel = useWhiteLabel();

  return useCallback<OnSubmit>(
    async ({ isDefaultPriceRange, priceRange, make, modelGroup, model }) => {
      // Google Analytics event
      pushAnalyticsEvent({
        event: 'hero stage',
        hero_category: 'auto',
        hero_action: getHeroAction(priceRange.key),
      });

      // always reset all pcp filters on submit
      dispatch(deleteAllFilters());

      // Generate target URL
      const url = getPcpUrl(
        isDefaultPriceRange,
        priceRange,
        make,
        modelGroup,
        model
      );

      if (whiteLabel?.merchantOrigin === 'winter-lausitz-de') {
        window.open(url.toString(), '_blank');
      } else {
        if (window !== window.top) {
          // If we are in an iframe, break out of it by opening the target URL in the topmost frame.
          // This is typically the case when /src/pages/whitelabel/widget-iframe.tsx was embedded on a
          // merchant website and the search is triggered by the user.
          window.open(url.toString(), '_top');
        } else {
          await router.push(url);
        }
      }
    },
    [dispatch, router, whiteLabel]
  );
};
